"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M14.39 18.5H9.611l.8 4h3.18l.799-4Zm1.11 0h-.089l-.2 1h.489c.33 0 .6-.224.6-.5l.001-.576c-.249.05-.516.076-.801.076Zm-7.8-.076V19c0 .276.27.5.6.5h.49l-.2-1H8.5c-.285 0-.552-.026-.8-.076ZM16.5 6.5h-8c-1.327 0-2 .673-2 2v8c0 .327.673 1 2 1h8c.327 0 1-.673 1-1v-8c0-1.327-.673-2-1-2Zm0 1c-.224 0 0 .224 0 1v7.997l-.005-.048c-.032-.135-.199.05.005.05h-8c-.724 0-.968-.194-.997-.038l-.003.033V8.5c0-.776.224-1 1-1h8Zm-1 1h-7v7h7v-7Zm3 7c0 1.064-.36 1.885-1.014 2.398A.36.36 0 0 1 17.5 18v1c0 .827-.808 1.5-1.8 1.5h-.6l-.088-.006-.52 2.604A.502.502 0 0 1 14 23.5h-4a.5.5 0 0 1-.49-.402l-.52-2.604-.045.004-.645.002c-.992 0-1.8-.673-1.8-1.5v-1a.42.42 0 0 1 .013-.103C5.86 17.385 5.5 16.564 5.5 15.5V10a.5.5 0 0 1-1 0V9a.5.5 0 0 1 1 0V7.5c0-.495.356-1.067 1.003-1.472L6.5 6V5c0-.827.808-1.5 1.8-1.5h.6l.089.006L9.51.902A.5.5 0 0 1 10 .5h4a.5.5 0 0 1 .49.402l.521 2.603.089-.005h.6c.992 0 1.8.673 1.8 1.5v1l-.003.028c.647.405 1.003.977 1.003 1.472V9a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v4a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v.5Zm-9.71-11H8.3c-.33 0-.6.224-.6.5v.572a4.33 4.33 0 0 1 .8-.072h.09l.2-1Zm6.91 0h-.49l.2 1h.09c.285 0 .552.025.8.072V5c0-.276-.27-.5-.6-.5Zm-2.11-3h-3.18l-.8 4h4.78l-.8-4Z",
    clipRule: "evenodd"
  })]
});